import useNextQueryParams from '@/hooks/useNextQueryParams'
import { AssetSelectionEnum, AssetSelectionModeParam } from '../../types'
import { TransferBar } from './Transfer'
import { ConvertToolbar } from './Convert'
import { UserAssets } from '@/api/resources/user/assets/get/schema'

const InventorySelectionToolbar = ({
  selectionLimit,
  loadedAssets
}: {
  loadedAssets: UserAssets
  selectionLimit: number | null
}) => {
  const { selectionMode } = useNextQueryParams<AssetSelectionModeParam>()
  if (!selectionMode) return null

  const isTransferMode = selectionMode === AssetSelectionEnum.Transfer

  return isTransferMode ? (
    <TransferBar loadedAssets={loadedAssets} />
  ) : (
    <ConvertToolbar
      loadedAssets={loadedAssets}
      selectionLimit={selectionLimit}
    />
  )
}

export default InventorySelectionToolbar
